import { TradingOfferOperationDetailContextType } from '../types/TradingOfferOperationDetailContextType';

export const tradingOfferOperationDetailInitValue: TradingOfferOperationDetailContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      operation: null,
      tradingOffer: null,
      operationReference: '',
      operationStatus: 'PENDING',
      timelineSteps: [],
      buyerInfo: null,
      sellerInfo: null,
      isAdmin: false,
      isLoading: true,
    },
    actions: {
      handleGoBack: () => {},
      handleUpdateStatus: () => {},
      handleGoToOffer: () => {},
    },
  };
